module.exports = __webpack_public_path__ + "static/img/tutorial-tool-attraction-1.75b505a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tutorial-tool-attraction-1.jpg
// module id = R/qx
// module chunks = 3